module.exports = __webpack_public_path__ + "static/media/by.d11a54e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/by.png
// module id = 1810
// module chunks = 0